import { useCallback, useEffect, useReducer } from "react";

const initialState = {
  data: null,
  isFetching: false,
  error: null,
  fetchCount: 0,
};
const actionTypes = {
  FETCH_START: "FETCH_START",
  FETCH_SUCCESS: "FETCH_SUCCESS",
  FETCH_FAILURE: "FETCH_FAILURE",
};
const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.FETCH_START:
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    case actionTypes.FETCH_SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.payload,
        fetchCount: state.fetchCount + 1,
      };
    case actionTypes.FETCH_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
const useApi = ({
  queryFn,
  queryKey = [],
  initialData = null,
  enabled = true,
}) => {
  const [state, dispatch] = useReducer(reducer, {
    ...initialState,
    isFetching: enabled,
    data: initialData,
  });

  const fetchData = useCallback(async () => {
    dispatch({ type: actionTypes.FETCH_START });
    try {
      const result = await queryFn();
      dispatch({ type: actionTypes.FETCH_SUCCESS, payload: result });
    } catch (error) {
      dispatch({ type: actionTypes.FETCH_FAILURE, payload: error });
    }
  }, [queryFn]);

  useEffect(() => {
    if (enabled) fetchData();
  }, [enabled, ...queryKey]);

  return {
    ...state,
    isLoading: state.fetchCount === 0 && state.isFetching,
    refetch: fetchData,
  };
};
export default useApi;
